import styled from 'styled-components'

export const DownloadSummaryButtonStyled = styled.button`
  background-color: transparent;
  border: none;
  width: 200px;

  div {
    float: left;
  }

  p {
    margin-top: 8px;
    text-decoration: underline;
    color: #3D6666;
  }
`